/* istanbul ignore file */
/**
 * Tooltip component theme configuration.
 */

export const tooltip = {
  root: {
    maxWidth: '250px',
    gutter: '4px',
    shadow: '{overlay.popover.shadow}',
    padding: '8px 12px',
    borderRadius: '{overlay.popover.border.radius}',
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.0}',
        color: '{neutral.1000}',
      },
    },
  },
};
